
































































import mixins from 'vue-typed-mixins';
import ResourceUtils, { Resource } from '@/utils/ResourceUtils';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  computed: {
    headers(): any[] {
      return [{ text: this.$tc('model.resource.name'), value: 'name' }];
    },
  },

  data(): {
    items?: Resource[];
    type?: 'create' | 'edit';
    pristine?: Partial<Resource>;
    item?: Partial<Resource>;
    file?: any;
  } {
    return {
      items: undefined,
      type: undefined,
      pristine: undefined,
      item: undefined,
      file: undefined,
    };
  },

  async mounted() {
    try {
      this.items = await ResourceUtils.api.resource.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async create() {
      this.type = 'create';
    },

    async edit(item: Resource) {
      this.type = 'edit';
      this.pristine = cloneDeep(item);
      this.item = cloneDeep(item);
    },

    async save() {
      try {
        (this.$refs.alert as any).hide('save');
        if (this.type === 'create' && this.items && this.file) {
          const item = await ResourceUtils.api.resource.add(this.file);

          // check if the item already exists in the list to make sure it isn't duplicated
          const index = this.items.findIndex(
            (value) => value.name === item?.name
          );
          if (index < 0) {
            this.items?.push(item);
          }

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.file?.name],
            }),
          });
          this.exit();
        } else if (this.type === 'edit' && this.items && this.item) {
          const item = await ResourceUtils.api.resource.edit(
            this.pristine as Resource,
            this.item
          );

          const index = this.items.findIndex(
            (value) => value.name === this.pristine?.name
          );
          if (index >= 0) {
            this.items[index] = item;
          }

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.item?.name],
            }),
          });

          this.exit();
        }
      } catch (error) {
        (this.$refs.alert as any).show('save', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    exit() {
      this.type = undefined;
      this.pristine = undefined;
      this.item = undefined;
      this.file = undefined;
    },

    async remove(item: Resource) {
      try {
        await this.$confirm(
          this.$i18n
            .t('validation.confirmation.delete', [item.name])
            .toString(),
          async () => {
            if (this.items) {
              await ResourceUtils.api.resource.remove(item.name);

              this.$toast.push({
                type: 'success',
                text: this.$languageobj('validation.success.delete', {
                  values: [item.name],
                }),
              });

              const index = this.items.findIndex(
                (val) => val.name === item.name
              );
              if (index >= 0) {
                this.items.splice(index, 1);
              }
            }
          }
        );
      } catch (error) {
        this.$alert.show('remove', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
